import request from '../utils/request.js'

/***************** 个人信息接口 *****************/
/**
 * 地址解析
 * @param params
 * @returns {AxiosPromise}
 */
export function getAddress(lat, lng) {
    return request({
        url: `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lng}&key=FVHBZ-GLM6O-UHIWF-SFNPY-NIWWF-6BFTN&get_poi=1`,
        method: 'get'
    })
}
/**
 * 账户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function current() {
    return request({
        url: '/api/account/current',
        method: 'get'
    })
}
/**
 * 首页统计
 * @param params
 * @returns {AxiosPromise}
 */
export function getCountHome() {
    return request({
        url: '/api/count/home',
        method: 'get'
    })
}
/**
 * 财务统计
 * @param params
 * @returns {AxiosPromise}
 */
export function getCountIncome() {
    return request({
        url: '/api/count/income',
        method: 'get'
    })
}


/**
 * 获取菜单
 * @param params
 * @returns {AxiosPromise}
 */
export function getMenus(params) {
    return request({
        url: `/api/account/menus`,
        method: 'get',
        params: params
    })
}
/**
 * 登录
 * @param params
 * @returns {AxiosPromise}
 */
export function login(params) {
    return request({
        url: '/api/account/login',
        method: 'post',
        data: params
    })
}
/**
 * 手机号登录
 * @param params
 * @returns {AxiosPromise}
 */
export function loginforcode(params) {
    return request({
        url: '/api/account/loginforcode',
        method: 'post',
        data: params
    })
}

/**
 * 发送短信
 * @param params
 * @returns {AxiosPromise}
 */
export function sendApplySms(params) {
    return request({
        url: '/api/account/send_apply_sms',
        method: 'post',
        data: params
    })
}


export function getUploadImgSrc(params) {
    return request({
        url: 'https://api.fxzb.vip/api/upload',
        method: 'post',
        data: params
    })
}

export function modifyPassword(params) {
    return request({
        url: '/api/account/modify_pwd',
        method: 'post',
        data: params
    })
}


export function setWithdraw(params) {
    return request({
        url: '/api/ticketer/withdraw/state',
        method: 'post',
        data: params
    })
}


export function seeWithdraw(params) {
    return request({
        url: '/api/ticketer/withdraw/state',
        method: 'get',
    })
}

/********************   卡卷库 ******************** */
//查询卡卷库
export function getEcardStore(params) {
    return request({
        url: '/api/ecard_store',
        method: 'get',
        params: params
    })
}
//导入卡劵
export function postEcardStore(params) {
    return request({
        url: '/api/ecard_store',
        method: 'post',
        data: params
    })
}
// 获取邀请设置配置
export function getInviteSetting() {
    return request({
        url: '/api/invite_setting',
        method: 'get',
    })
}
// 保存邀请设置配置
export function postInviteSetting(params) {
    return request({
        url: '/api/invite_setting',
        method: 'post',
        data: params
    })
}

// 获取全局禁用时间段
export function getGlobalDisableTime() {
    return request({
        url: '/api/ticketer/global_disable_time',
        method: 'get',
    })
}
// 保存全局禁用时间段
export function globalDisableTime(params) {
    return request({
        url: '/api/ticketer/global_disable_time',
        method: 'post',
        data: params
    })
}

// 出票设置
export function getTakeTicket() {
    return request({
        url: '/api/setting/take_ticket',
        method: 'get',
    })
}
// 保存出票设置
export function postTakeTicket(params) {
    return request({
        url: '/api/setting/take_ticket',
        method: 'post',
        data: params
    })
}

// 积分设置
export function getIntegral() {
    return request({
        url: '/api/setting/integral',
        method: 'get',
    })
}
// 保存积分设置
export function postIntegral(params) {
    return request({
        url: '/api/setting/integral',
        method: 'post',
        data: params
    })
}
/**
 * 获取弃单原因
 * @param params
 * @returns {AxiosPromise}
 */
export function getDiscard() {
    return request({
        url: '/api/setting/discards',
        method: 'get',
    })
}
/**
 * 弃单原因设置
 * @param params
 * @returns {AxiosPromise}
 */
export function postDiscard(params) {
    return request({
        url: `/api/setting/discards`,
        method: 'post',
        data: params
    })
}
/**
 * 获取开启/关闭兜底
 * @param params
 * @returns {AxiosPromise}
 */
export function getPocketState() {
    return request({
        url: '/api/setting/pocket_state',
        method: 'get',
    })
}
/**
 * 开启/关闭兜底
 * @param params
 * @returns {AxiosPromise}
 */
export function postPocketState(params) {
    return request({
        url: `/api/setting/pocket_state`,
        method: 'post',
        data: params
    })
}


/**
 * 获取弃单自动分配
 * @param params
 * @returns {AxiosPromise}
 */
export function getGiveupMapping() {
    return request({
        url: '/api/setting/giveup_mapping',
        method: 'get',
    })
}
/**
 * 设置弃单自动分配
 * @param params
 * @returns {AxiosPromise}
 */
export function postGiveupMapping(params) {
    return request({
        url: '/api/setting/giveup_mapping',
        method: 'post',
        data: params
    })
}
/**
 * 获取字典数据
 * @param params
 * @returns {AxiosPromise}
 */
export function getDictList(params) {
    return request({
        url: `/api/dict/list`,
        method: 'get',
        params: params
    })
}

/**
 * 机器人接单轮数
 * @param params
 * @returns {AxiosPromise}
 */
export function getRobotBidRound(params) {
    return request({
        url: `/api/setting/robot_bid_round`,
        method: 'get',
        params: params
    })
}
/**
 * 设置机器人接单轮数
 * @param params
 * @returns {AxiosPromise}
 */
export function postRobotBidRound(params) {
    return request({
        url: '/api/setting/robot_bid_round',
        method: 'post',
        data: params
    })
}
/**
 * 禁用票根验证的时间段
 * @param params
 * @returns {AxiosPromise}
 */
export function getDisableOrderTimes(params) {
    return request({
        url: `/api/setting/disable_order_times`,
        method: 'get',
        params: params
    })
}
/**
 * 设置禁用票根验证的时间段
 * @param params
 * @returns {AxiosPromise}
 */
export function postDisableOrderTimes(params) {
    return request({
        url: '/api/setting/disable_order_times',
        method: 'post',
        data: params
    })
}

/**
 * 积分明细
 * @param params
 * @returns {AxiosPromise}
 */
export function getIntegralDetail(params) {
    return request({
        url: `/api/integral/detail`,
        method: 'get',
        params: params
    })
}
/**
 * 积分拒绝申诉
 * @param params
 * @returns {AxiosPromise}
 */
export function postIntegralReject(params) {
    return request({
        url: '/api/integral/reject',
        method: 'post',
        data: params
    })
}
/**
 * 积分通过申诉
 * @param params
 * @returns {AxiosPromise}
 */
export function postIntegralResolve(params) {
    return request({
        url: '/api/integral/resolve',
        method: 'post',
        data: params
    })
}
/**
 * 统计
 * @param params
 * @returns {AxiosPromise}
 */
export function getCount(params) {
    return request({
        url: `/api/count`,
        method: 'get',
        params: params
    })
}

/**
 * 统计
 * @param params
 * @returns {AxiosPromise}
 */
export function getStatement(params) {
    return request({
        url: `/api/account/statement`,
        method: 'get',
        params: params
    })
}

/**
* 搜索碰一碰教程
* @param params
* @returns {AxiosPromise}
*/
export function getSystemNotice(params) {
    return request({
        url: '/api/system_notice',
        method: 'get',
        params: params
    })
}
/**
 * 搜索碰一碰教程详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getSystemNoticeId(id) {
    return request({
        url: `/api/system_notice/${id}`,
        method: 'get',
    })
}
/**
 * 保存商家配置
 * @param params
 * @returns {AxiosPromise}
 */
export function postKeeperTouch(params) {
    return request({
        url: '/api/keeper_touch',
        method: 'post',
        data: params
    })
}
/**
 * 配置:腾讯地图key
 * @param params
 * @returns {AxiosPromise}
 */
export function getTencentKey(params) {
    return request({
        url: `/api/platform/tencent_key`,
        method: 'get',
        params:params
    })
}
/**
 * 下载海报
 * @param params
 * @returns {AxiosPromise}
 */
export function getQrcodeInvitePromoter(appId,params) {
    return request({
        url: `/api/qrcode/invite_promoter/${appId}`,
        method: 'get',
        params:params
    })
}

/**
 * 平台配置V2
 * @param params
 * @returns {AxiosPromise}
 */
export function getPlatformConfigV2(params) {
    return request({
        url: `/api/platform/configV2`,
        method: 'get',
        params: params
    })
}
/**
 * 冻结明细
 * @param params
 * @returns {AxiosPromise}
 */
export function getAccountLockOrder(params) {
    return request({
        url: `/api/account/lock_order`,
        method: 'get',
        params: params
    })
}